<template>
  <Modal>
    <Modal.Title>Can't pay here</Modal.Title>
    <Modal.Body>
      <p class="text-[14px] leading-[22px] text-gray-800">
        Please go to Dacr.com to pay your outstanding balance.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :size="isMobile ? 'lg' : 'md'" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :size="isMobile ? 'lg' : 'md'"
        @click="handleGoClick"
      >
        Go to Dacr.com
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'

import { useDevice } from '@/shared/composables/useDevice'
import { useCantPay } from './useCantPay'

const { close } = useModal()
const { isMobile } = useDevice()
const { handleGo } = useCantPay()

const handleGoClick = () => {
  handleGo()
  close()
}
</script>
